module.exports = __webpack_public_path__ + "static/img/icon_ep_num.05fd3db5.png";